<script lang="ts">
    import {Button} from 'svelma';
    import ModalElement from "../ModalElement.svelte";
    import Manager from "../../../application/SyllabusManager/models/Manager.ts";
    import {_} from "svelte-i18n";

    export let manager: Manager;
    export let subjectArray;
    export let dividerTitle;
    export let subjectStore;
    export let languages;

    function changeSubject(id){$subjectStore = manager.subjectManager.getSubject(id);}
</script>

{#if subjectArray.length > 0}
    <div class="divider">{dividerTitle}</div>
    {#each subjectArray as subjectId,i}
        {#if subjectArray.length>1}
            <div class="divider">{i+1}.</div>
        {/if}
        {#if manager.subjectManager.getSubject(subjectId) !== null}
            {#if $languages === 'hu'}
                <ModalElement lead={$_('subjectCard.name')} text={manager.subjectManager.getSubject(subjectId).nameHu}/>
            {/if}
            {#if $languages === 'en'}
                <ModalElement lead={$_('subjectCard.name')} text={manager.subjectManager.getSubject(subjectId).nameEn}/>
            {/if}
            <ModalElement lead={$_('subjectCard.credit')} text={manager.subjectManager.getSubject(subjectId).credits}/>
            <ModalElement lead={$_('subjectCard.code')} text={manager.subjectManager.getSubject(subjectId).code}/>
        {/if}
        <Button size="is-small" on:click={()=>changeSubject(subjectId)}>{$_('subjectCard.subDetails')}</Button>
    {/each}
{/if}
